import { deletePurchaseTemplate, fetchPurchaseTemplates, selectPurchaseTemplate, resetCurrentPurchaseTemplate, fetchPurchaseTemplateList } from '../../actions/purchaseTemplates_actions';
import { connect } from 'react-redux';

import PurchaseTemplateList from '../../components/Purchase/purchaseTemplateList'

function mapStateToProps(state) {
    return {
        currentPurchaseTemplate: state.purchaseTemplates.currentPurchaseTemplate,
        purchaseTemplates: state.purchaseTemplates.all,
        isLoading: state.purchaseTemplates.isLoading,
        error: state.purchaseTemplates.error,
        userPermissions: state.auth.userPermissions,
        purchaseTemplateList: state.purchaseTemplates.purchaseTemplateList,
        purchaseTemplateListIsLoading: state.purchaseTemplates.purchaseTemplateListIsLoading,
        purchaseTemplateListError: state.purchaseTemplates.purchaseTemplateListError,
    };
}

export default connect(mapStateToProps, { deletePurchaseTemplate, fetchPurchaseTemplates, selectPurchaseTemplate, resetCurrentPurchaseTemplate, fetchPurchaseTemplateList })(PurchaseTemplateList);



// WEBPACK FOOTER //
// ./master/jsx/containers/Purchase/purchaseTemplateList.jsx